import React from 'react';
import PropTypes from 'prop-types';
// Custom
import AppIcon from 'components/icons/AppIcon';

const InfoCheckbox = ({ value }) => (
  <div className="d-flex align-items-center">
    <AppIcon id={value ? 'checkActive' : 'checkInactive'} defaultColor />
  </div>
);

InfoCheckbox.propTypes = {
  value: PropTypes.bool.isRequired,
};

module.exports = InfoCheckbox;



// WEBPACK FOOTER //
// ./components/misc/InfoCheckbox.js